import React from 'react'
import { IconLogoDefault } from '@mc/design-system'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { paths } from '@mc/paths'
import {
  NavigationEvents,
  PageLoadEvents,
  trackGoldStandardEvent,
} from '@mc/track-event'
import { CHECKOUT_I18N_NAMESPACE, i18nInstance } from '../../../../i18n'
import { useCheckoutMachine } from '../../../../lib'
import LogoWordmark from '../../assets/logoWordmark.svg'

export const LogoComp = () => {
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)
  const ctx = useCheckoutMachine()

  const trackLogoClick = () => {
    trackGoldStandardEvent(NavigationEvents.EVENTS.NAVIGATION_CLICKED, {
      action: 'MC Logo',
      level: NavigationEvents.LEVELS.PRIMARY,
      page_source: ctx.context?.checkoutPageSource || PageLoadEvents.PLANS,
    })
  }

  return (
    <a href={paths.root} onClick={trackLogoClick}>
      <div className='d-flex align-items-center'>
        <IconLogoDefault className='mc-text-color--primary' size={6} />
        <LogoWordmark
          className='d-none d-lg-block mc-ml-2'
          style={{ width: 100 }}
        />
        <span className='mc-sr-only'>{t('nav.cta.logo')}</span>
      </div>
    </a>
  )
}

export const Logo = withI18nContext(i18nInstance)(LogoComp)
